import { createContext } from 'react';
import { IPasswordPolicyContext } from './types';

const PasswordPolicyContext = createContext<IPasswordPolicyContext | undefined>(
  undefined,
);

export default PasswordPolicyContext;
